import { useState } from 'react'
import { api, ApiError } from '../api'
import { useAuth } from '../App'
import { Alert, Field } from '../components/ui'

export default function Setup() {
  const { refresh } = useAuth()
  const [name, setName] = useState('Lov Kumar Singh')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    if (password !== confirm) return setError('The two passwords do not match')
    if (password.length < 10) return setError('Use at least 10 characters')

    setBusy(true)
    try {
      await api.post('/auth/setup', { name, email, password })
      await refresh()
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Setup failed')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-box">
        <div className="logo">
          <div className="n">DIGIAUD (OPC) PRIVATE LIMITED</div>
          <div className="s">GSTIN 10AAICD5601M1ZW · Patna, Bihar</div>
        </div>
        <div className="card">
          <h2 style={{ marginBottom: 4 }}>Create your account</h2>
          <p className="muted small" style={{ marginTop: 0, marginBottom: 18 }}>
            This is the one-time setup. It only works while no account exists, so nobody else can
            claim ownership later.
          </p>

          <Alert kind="error">{error}</Alert>

          <form onSubmit={submit}>
            <Field label="Your name">
              <input type="text" value={name} onChange={(e) => setName(e.target.value)} required />
            </Field>
            <Field label="Email address" hint="This is your sign-in ID.">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="username"
              />
            </Field>
            <Field label="Password" hint="At least 10 characters. Stored as a PBKDF2 hash, never in plain text.">
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="new-password"
              />
            </Field>
            <Field label="Confirm password">
              <input
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
                autoComplete="new-password"
              />
            </Field>
            <button className="btn primary" style={{ width: '100%', justifyContent: 'center' }} disabled={busy}>
              {busy ? 'Creating…' : 'Create account'}
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}
